var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-pre"},[_c('iframe',{style:('width: 100%; height:'+_vm.min_height+'px'),attrs:{"src":_vm.officeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }